import { supabase } from "@/services";
import { getUser } from ".";

export const getImagesByAppointmentId = async (appointmentId: string) => {
  try {
    const { data, error: imagesError } = await supabase
      .from("images")
      .select("*")
      .eq("appointment_id", appointmentId)
      .eq("type", "image");

    if (imagesError) {
      throw new Error("Error getting images: " + imagesError.message);
    }

    if (!data) {
      return [];
    }

    return data;
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message);
    } else {
      console.error("An unknown error occurred:", error);
    }
    return [];
  }
};

export const deleteImage = async (imageUrl: string) => {
  const user = await getUser();

  if (!user) {
    console.error("User not found");
    return { success: false, message: "User not found" };
  }

  const urlParts = imageUrl.split("/");
  const fileName = urlParts[urlParts.length - 1];

  const { error: storageError } = await supabase.storage
    .from("appointments_images")
    .remove([`${user.id}/${fileName}`]);

  if (storageError) {
    console.error("Error deleting image from storage:", storageError.message);
    return { success: false, message: "Error deleting image from storage." };
  }

  const { error: deleteError } = await supabase
    .from("images")
    .delete()
    .eq("image_url", imageUrl);

  if (deleteError) {
    console.error("Error deleting image from database:", deleteError.message);
    return { success: false, message: "Error deleting image from database." };
  }

  return { success: true, message: "Image removed successfully." };
};

export const getImagesByProjectId = async (projectId: string) => {
  const { data: images, error: imagesError } = await supabase
    .from("images")
    .select("image_id, appointment_id, user_id, image_url")
    .eq("project_id", projectId)
    .not("image_url", "like", "%signatures%");

  if (imagesError) {
    console.error("Error fetching images:", imagesError);
    return null;
  }

  return images;
};
